<template>
  <div v-if="userName" class="user-poptip">
    <Poptip @on-popper-show="open" width="400">
      <span v-if="userName.length > 5" class="user-name dashed">{{ userName | subString(4) }}</span>
      <span v-else class="user-name dashed">{{ userName }}</span>
      <div slot="content" class="poptip-box">
        <div class="user-box" @click="openForm">
          <i class="dian" :class="{ 'red': formData.workingState == 0, 'orange': formData.isSus == 1 }"></i>
          <span class="user-name line">{{ userName }}</span>
        </div>
        <div class="table-text-box">
          <div class="item full" v-if="formData.organizationName">
            <label>所属机构：</label>
            <div class="text">{{ formData.organizationName }}</div>
          </div>
          <div class="item">
            <label>工号：</label>
            <div class="text">{{ formData.staffNo }}</div>
          </div>
          <div class="item">
            <label>入职日期：</label>
            <div class="text">{{ formData.entryTime ? formData.entryTime.substring(0, 10) : "" }}</div>
          </div>
          <div class="item">
            <label>当前职级：</label>
            <div class="text">{{ formData.rankName }}</div>
          </div>
          <div class="item full">
            <label>联系电话：</label>
            <div class="text" v-if="eyeShow">{{ formData.mobile }}</div>
            <div class="text" v-else>{{ formData.mobile1 }}</div>
            <i class="iconfont iconxianshi eye-icon" v-if="eyeShow" @click="openEye"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye"></i>
          </div>
        </div>
        <div class="table-title">职级变更记录</div>
        <Table :columns="columns1" :data="tableData">
          <template slot-scope="{ row }" slot="newRankName">
              <span v-if="row.oldRankName">
              【{{ row.oldRankName }}】→
              </span>
              【{{ row.newRankName }}】
          </template>
        </Table>
      </div>
    </Poptip>
  </div>
</template>

<script>
import tooltip from '@/components/commons/tooltip'
import { common } from "@/api/mixins";
export default {
  mixins: [common],
  components: { tooltip },
  props: {
    id: null,
    userName: null,
    operationFunction:null
  },
  data() {
    return {
      formData: {},
      tableData: [],
      loading: false,
      eyeShow: false,
      columns1: [
        {
          title: "生效时间",
          key: "effectiveDate",
          align: "center",
          render(h, params) {
            const date = params.row.effectiveDate ? params.row.effectiveDate.substring(0, 10) : '';
            return <span>{date}</span>;
          },
          minWidth: 130
        },
        {
          title: "职级",
          slot: "newRankName",
          align: "center",
          minWidth: 220
        },
      ],
    };
  },
  watch: {},
  computed: {},
  created() { },
  mounted() { },
  methods: {
    open() {
      this.loading = true;
      Promise.all([
        this.getUserData(),
        this.getList(),
      ]).then(() => {
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      });
    },
    // 用户数据
    getUserData() {
      return this.$http({
        url: '/buz/userBase/read/detail',
        type: 'get',
        data: {
          id: this.id,
        },
      }).then((res) => {
        this.formData = res.data;
      })
    },
    // 职级记录
    getList() {
      return this.$http({
        url: '/buz/userRankChangeRecord/read/list',
        type: 'POST',
        data: {
          userId: this.id,
          pageNo: "1",
          pageSize: "99",
          status: "1",
        },
      }).then((res) => {
        this.tableData = res.data;
      })
    },
    // 打开表单
    openForm() {
      this.$router.push({
        path: "/orgManage/salesmanForm/" + this.formData.id,
        query: {
          groupId: this.formData.groupId,
          userId: this.formData.id,
          route: this.$route.fullPath,
          timeStr: new Date().getTime()
        }
      })
    },
    openEye() {
      if (this.eyeShow == false) {
        this.descrypt({
          query: this.formData.id,
          operationFunction: this.operationFunction? this.operationFunction:1,
          operationType: 2,
        }, this.formData, 'mobile').then(() => {
          this.eyeShow = true
        })
      } else {
        this.eyeShow = false
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.user-poptip /deep/ .poptip-box {
  // width: 340px;
  font-size: 13px;

  .dian {
    display: block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;

    &.red {
      background: #E3461F !important;
    }
  }

  .eye-icon {
    font-size: 16px;
    line-height: 1;
    margin-left: 4px;
    cursor: pointer;
  }

  .table-text-box {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;

    .item {
      width: 50%;
      display: flex;
      align-items: center;
      padding-top: 6px;
      padding-right: 10px;

      &.full {
        width: 100%;
      }

      label {
        color: #515C6F;
        margin-bottom: auto;
      }

      .text {
        color: #3C464F;
        white-space: normal;
        margin-bottom: auto;
      }
    }
  }

  .table-title {
    padding: 8px 0;
    text-align: left;
    color: #3C464F;
    font-size: 13px;
  }

  tr.ivu-table-row-hover td {
    background-color: #fff;
  }

  .ivu-table {
    margin-bottom: 0;
  }

  .ivu-table th,
  .ivu-table td {
    height: 26px;
    padding: 0;
    font-size: 13px;
    font-weight: initial;
    background-color: #fff;
  }

  .user-box {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #236DFF;
    height: 22px;
    padding-left: 0;
    justify-content: left;

    &.text {
      color: #515C6F;
    }

    .user-name {
      cursor: pointer;

      &.dashed {
        border-bottom: 1px dashed #236DFF;
      }

      &.line {
        border-bottom: 1px solid #236DFF;
      }
    }

    i {
      color: #BABABA;
      font-size: 12px;
    }

    .iconduichang {
      margin-left: 4px;
      color: #ed8b43;
    }
  }
  .iconfont{
    color: #3C464F;
  }
}</style>